import infoApi from './info';
import passwordApi from './password';
import imagesApi from './images';
import businessCardsApi from './businessCards';
import messagesApi from './messages';
const $api = Object.assign({}, 
	infoApi,
	passwordApi,
	imagesApi,
	businessCardsApi,
	messagesApi,
);

export default $api;


// WEBPACK FOOTER //
// ./src/service/usercenter/index.js